import { ApiError } from '../api/api-client';
import { AxiosError } from 'axios';

import proxyClient from '../lib/proxyClient';

import { Languages } from './constants';

export interface CustomerByProps {
  customerNumber: string;
  studioId: string;
  dateOfBirth: string;
  lang: Languages;
}


interface ExtensionCustomer {
  venue_id: string;
  customer_id: string;
  end_date: string
  has_payment_method: boolean
  jwt_token: string
}

export const getCustomerBy = async ({
  customerNumber,
  studioId,
  dateOfBirth,
  lang,
}: CustomerByProps) => {
  try {
    const { data } = await proxyClient.get<ExtensionCustomer>('/frontend/customer_extension', {
      params: {
        customer_number: customerNumber,
        date_of_birth: dateOfBirth,
        venue_id: studioId,
      },
      headers: {
        'Accept-Language': lang,
      },

    });
    return data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new ApiError(error);
    }
    if (error instanceof ApiError) {
      throw error;
    }
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};
